import React from 'react'
import classes from './cardimage.module.css'
import Image from '../../../Image/Image'
import classNames from 'classnames'

const cardImageVariants = {
    FULL: classes.cardImageFull,
    HALF: classes.cardImageHalf,
    CURVED: classes.cardImageCurved,
}

function CardImage({
    url,
    badges = [],
    className,
    variant,
    errorImageUrl = null,
}) {
    return (
        <div className={classes.cardImageWrapper}>
            <Image
                src={url}
                alt="Card Image"
                className={classNames(
                    classes.cardImage,
                    cardImageVariants[variant],
                    className
                )}
                width={'100%'}
                errorImageUrl={errorImageUrl}
            />
            {badges.map(badge => (
                <>{badge}</>
            ))}
        </div>
    )
}

export default CardImage
